/*
 * NMBI number: the registration number (PIN) the Nursing and Midwifery Board of Ireland issues to
 * every nurse and midwife on its register. It is stored apart from the Medical Council number,
 * which lab orders and referrals send as a doctor's MCN (KIN-2099 / KIN-2111).
 *
 * Five or six digits, nothing else — the same rule the backend enforces (NmbiNumberValidator),
 * mirrored here so a mistyped number is caught in the form instead of coming back as a bare 400.
 * Widen both together if a real PIN is ever refused.
 */
const FIVE_OR_SIX_DIGITS = /^\d{5,6}$/;

export const NMBI_NUMBER_ERROR =
  "An NMBI number is five or six digits. Leave it empty if this staff member does not have one.";

/** True when the number is five or six digits. */
export const isValidNmbiNumber = (nmbiNumber) =>
  typeof nmbiNumber === "string" && FIVE_OR_SIX_DIGITS.test(nmbiNumber);

/** True when no NMBI number has been entered at all. */
export const isNmbiNumberAbsent = (nmbiNumber) =>
  !nmbiNumber || nmbiNumber.trim().length === 0;

/**
 * What a form should accept: a valid number, or none at all. Doctors and non-clinical staff have
 * no PIN, so an empty field is never an error.
 */
export const isAcceptedNmbiNumber = (nmbiNumber) =>
  isNmbiNumberAbsent(nmbiNumber) || isValidNmbiNumber(nmbiNumber);
